module.exports = __webpack_public_path__ + "img/118.7d1ed545.png";